import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faPowerOff, faQuestionCircle } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, NavLink } from "react-router-dom";
import { brunetUrl, fakturyUrl } from "../helpers/appUrls";
import useWybranaOrganizacja from "../hooks/useWybranaOrganizacja";
import { authActions } from "../store/actions/auth.actions";
import { IDRaksStore } from "../store/store";
import { OrganizacjaWidok, Produkt } from "../store/types/organizacje";
import NavStyle from "../styles/NavStyle";

interface NavProps {
  openedDrawer?: boolean;
  onLogout: Function;
  wybrana: OrganizacjaWidok;
}

const Nav = (props: NavProps) => {
  const { openedDrawer, onLogout, wybrana } = props;
  const { idWybranej: id } = useWybranaOrganizacja();
  const [czyDostepnyBrunet, setCzyDostepnyBrunet] = useState(false);
  const [czyDostepnyZioom, setCzyDostepnyZioom] = useState(false);

  const otworzPomoc = () => (window as any).Beacon("open");

  useEffect(() => {
    if (wybrana && wybrana.Produkty) {
      setCzyDostepnyZioom(wybrana.Produkty.includes(Produkt.Zioom));
      setCzyDostepnyBrunet(wybrana.Produkty.includes(Produkt.Brunet));
    }
  }, [wybrana]);

  return (
    <NavStyle openedDrawer={openedDrawer}>
      {openedDrawer ? (
        <div className="options">
          <p className="title overline">ORGANIZACJA</p>
          <NavLink to={`/${id}/organizacje`} className="nav-link">
            <div className="name">{wybrana.Nazwa || "BRAK"}</div>
          </NavLink>
          <p className="title overline">PROFIL UŻYTKOWNIKA</p>
          <NavLink to={`/${id}/daneosobiste`} className="nav-link">
            <div>Dane osobiste</div>
          </NavLink>
          <NavLink to={`/${id}/zmianahasla`} className="nav-link">
            <div>Hasło</div>
          </NavLink>
          {wybrana.CzyMoznaAdministrowac && (
            <>
              <p className="title overline">UŻYTKOWNICY</p>
              <NavLink to={`/${id}/uzytkownicy`} className="nav-link">
                <div>Użytkownicy</div>
              </NavLink>
            </>
          )}
          {(czyDostepnyZioom || czyDostepnyBrunet) && (
            <p className="title overline">APLIKACJE</p>
          )}
          {czyDostepnyZioom && (
            <a
              href={fakturyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              <div>FAKTURY</div>
            </a>
          )}
          {czyDostepnyBrunet && (
            <a
              href={brunetUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link"
            >
              <div>BRUNET</div>
            </a>
          )}
        </div>
      ) : (
        <div />
      )}
      <div className="footer">
        {openedDrawer && (
          <>
            <Link
              to="/"
              onClick={() => {
                onLogout();
              }}
            >
              <button className="faBtn">
                <FontAwesomeIcon
                  className="fa-icon"
                  icon={faPowerOff as IconProp}
                />
              </button>
            </Link>
            <Tooltip title="Pomoc">
              <button className="faBtn" onClick={otworzPomoc}>
                <FontAwesomeIcon
                  className="fa-icon"
                  icon={faQuestionCircle as IconProp}
                />
              </button>
            </Tooltip>
            <div />
          </>
        )}
      </div>
    </NavStyle>
  );
};

const mapStateToProps = (store: IDRaksStore) => {
  return {
    wybrana: store.organizacje.wybrana,
  };
};

const mapDispatchToProps = (dispatch: Function) => {
  return {
    onLogout: () => dispatch(authActions.logout()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Nav);
